import React from "react";
import Select from "react-select";
import trashIcon from '../../assets/images/trash-icon.png';
import { formatUSD } from '../../utils/common';

const QuoteCustomerSalesTable = ({ salesData, setFormData, products, productMap, multiplierMap, rowErrors }) => {

    const TAX_RATE = 0.00; // 0%

    const recalculateTotals = (updatedSales) => {
        const subTotal = updatedSales.reduce(
            (sum, row) => sum + Number(row.total_price || 0),
            0
        );

        const salesTax = subTotal * TAX_RATE;
        const total = subTotal + salesTax;

        return {
            sub_total: subTotal.toFixed(2),
            sales_tax: salesTax.toFixed(2),
            total: total.toFixed(2)
        };
    };

    const handleProductSelect = (index, selected) => {
        if (!selected) return;

        const product = productMap[selected.value];
        if (!product) return;

        const multiplier =
            multiplierMap[product.multiplier_code] || 1;

        const unitPrice = (
            Number(product.price)
        ).toFixed(2);

        setFormData(prev => {
            const rows = [...prev.sales_data];

            rows[index] = {
                ...rows[index],
                product_number: product.num,
                description: product.description,
                unit_price: unitPrice,
                quantity: rows[index].quantity || "",
                multiplier: multiplier,
                total_price: rows[index].quantity
                    ? (rows[index].quantity * unitPrice).toFixed(2)
                    : "0.00"
            };

            return {
                ...prev,
                sales_data: rows
            };
        });
    };


    const recalcTotals = (rows) => {
        const sub = rows.reduce(
            (sum, r) => sum + Number(r.total_price || 0),
            0
        );
        const tax = sub * TAX_RATE;
        return {
            sub_total: sub.toFixed(2),
            sales_tax: tax.toFixed(2),
            total: (sub + tax).toFixed(2)
        };
    };

    const handleQtyChange = (index, value) => {
        const qty = Number(value);

        setFormData(prev => {
            const rows = [...prev.sales_data];
            const price = Number(rows[index].unit_price || 0);
            const multiplier = Number(rows[index].multiplier || 1)

            rows[index] = {
                ...rows[index],
                quantity: qty,
                total_price: (qty * price * multiplier).toFixed(2)
            };

            // auto add row
            if (qty > 0 && index === rows.length - 1) {
                rows.push({
                    type: "Sale",
                    product_number: "",
                    description: "",
                    unit_price: "0.00",
                    quantity: "",
                    total_price: "0.00"
                });
            }

            return {
                ...prev,
                sales_data: rows,
                ...recalcTotals(rows)
            };
        });
    };

    const removeRow = (index) => {
        setFormData(prev => {
            const rows = prev.sales_data.filter((_, i) => i !== index);
            return {
                ...prev,
                sales_data: rows,
                ...recalculateTotals(rows)
            };
        });
    };

    return (
        <table className="table table-bordered techtop-quote-table2">
            <thead>
                <tr>
                    <th className="text-center" style={{ width: "6%" }}>Item #</th>
                    <th className="text-center">Type</th>
                    <th className="text-center" style={{ width: "25%" }}>Number</th>
                    <th className="text-center" style={{ width: "30%" }}>Description</th>
                    <th className="text-center">Unit Price</th>
                    <th className="text-center" style={{ width: "8%" }}>Qty</th>
                    <th className="text-center">Total</th>
                    <th className="text-center">Action</th>
                </tr>
            </thead>
            <tbody>
                {salesData.map((row, index) => (
                    <tr key={index}>
                        <td className="text-center">{index + 1}</td>
                        <td className="text-center">{row.type}</td>
                        <td>
                            <Select
                                options={products}
                                value={
                                    row.product_number
                                        ? { value: row.product_number, label: row.product_number }
                                        : null
                                }
                                onChange={(opt) => handleProductSelect(index, opt)}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            />
                            {rowErrors?.[index]?.product_number && (
                                <div className="text-danger small">
                                    {rowErrors[index].product_number}
                                </div>
                            )}
                        </td>
                        <td>{row.description}</td>
                        <td className="text-center">${formatUSD(row.unit_price)}</td>
                        <td>
                            <input
                                type="number"
                                className="form-control"
                                value={row.quantity}
                                onChange={(e) => handleQtyChange(index, e.target.value)}
                            />
                            {rowErrors?.[index]?.quantity && (
                                <div className="invalid-feedback d-block">
                                    {rowErrors[index].quantity}
                                </div>
                            )}
                        </td>
                        <td className="text-center">${formatUSD(row.total_price)}</td>
                        <td className="text-center btn-link-style">
                            {salesData.length > 1 && (
                                <img className="remove-icon" src={trashIcon} alt="Remove" onClick={() => removeRow(index)} />
                            )}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default React.memo(QuoteCustomerSalesTable);